import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import AddEditManual from "../components/discounts/manualDiscount/addEditManual";
import ViewDiscount from "../components/discounts/shared/viewDiscount";
import { forSlideFromLeftAnimation } from "../shared/hooks/funcions";
import CommonDiscountList from "../shared/commonComponents/commonDiscountList";

const ManualDiscount = () => <CommonDiscountList type="Manual" />

// custom imports
/* 
  Functional component to hold all the pages in a stack navigator
 */
const ManualDiscountStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={"ManualDiscount"}
            screenOptions={{ headerShown: false, cardStyleInterpolator: forSlideFromLeftAnimation }}>
            <AppStack.Screen name="ManualDiscount" component={ManualDiscount} />
            <AppStack.Screen name="AddEditManual" component={AddEditManual} />
            <AppStack.Screen name="ViewDiscount" component={ViewDiscount} />
        </AppStack.Navigator>
    );
};

export default ManualDiscountStack;